export default "__VITE_ASSET__sMryIJT1__"